// extracted by mini-css-extract-plugin
module.exports = {"btn-outline-primary":"_7SH24PSwQRpzVABAk57aP","button-disconnect":"_11Jf05vWCu6K1OIQiH7LCN","btn-action":"IsdPs2HL1CpfLRCjHH9li"};